export default __webpack_public_path__ + "static/mafo-45289f30a3512f3c2a5812e1d1944bf0.png";